import React, { useState } from 'react';
import axios from '../api/axiosConfig';

const TIPOS_DOC = [
  ['CC', 'cédula de ciudadanía'], ['NIT', 'nit'], ['CE', 'cédula de extranjería'],
  ['PP', 'pasaporte'], ['PPT', 'permiso de permanencia temporal (PPT)'], ['TI', 'tarjeta de identidad']
];
const EXT_OK = ['pdf', 'jpg', 'jpeg', 'png', 'webp'];
// Documentos obligatorios (nombre del campo que recibe el servidor)
const DOCUMENTOS = [
  { campo: 'Contrato_Compraventa', etiqueta: 'CONTRATO DE COMPRAVENTA AUTENTICADO' },
  { campo: 'Mandato_Comprador', etiqueta: 'CONTRATO DE MANDATO DEL COMPRADOR (FIRMADO Y CON HUELLA)' },
  { campo: 'Mandato_Vendedor', etiqueta: 'CONTRATO DE MANDATO DEL VENDEDOR (FIRMADO Y CON HUELLA)' },
  { campo: 'Cedula_Comprador', etiqueta: 'CÉDULA DEL COMPRADOR' },
  { campo: 'Cedula_Vendedor', etiqueta: 'CÉDULA DEL VENDEDOR' },
  { campo: 'FUN', etiqueta: 'FUN' }
];
const TITULOS = {
  traspaso: { titulo: 'TRASPASO', valor: '$41.600' },
  traspaso_levante_prenda: { titulo: 'TRASPASO CON LEVANTE DE PRENDA', valor: '$50.400' }
};

const Estado = ({ ok, children }) => (
  <div style={{ color: ok ? '#15803d' : '#b91c1c', fontWeight: 600 }}>{ok ? '✅' : '❌'} {children}</div>
);

// Bloque de datos de una persona (comprador o vendedor) con consulta de RUNT/SIMIT
const Persona = ({ titulo, icono, p, setP, conContacto }) => {
  const [buscando, setBuscando] = useState(false);
  const set = (k, v) => setP(prev => ({ ...prev, [k]: v }));
  const buscar = async () => {
    if (!p.documento) { alert('⚠️ Ingrese el documento'); return; }
    setBuscando(true);
    try {
      const res = await axios.get(`/api/tramites/owner/${p.documento}?tipo_documento_id=${p.tipo_documento}`);
      if (res.data) {
        setP(prev => ({
          ...prev,
          nombre: res.data.propietario || prev.nombre,
          correo: res.data.correo || prev.correo, telefono: res.data.telefono || prev.telefono, direccion: res.data.direccion || prev.direccion,
          estado_persona: res.data.estado_persona || null, tiene_multas: Boolean(res.data.tiene_multas)
        }));
        if (res.data.tiene_multas) alert(`🚨 El ${titulo.toLowerCase()} presenta multas en SIMIT.`);
      }
    } catch (err) {
      alert(err.response?.status === 404 ? 'ℹ️ Persona no encontrada. Ingrese los datos manualmente.' : '❌ Error al consultar');
    } finally { setBuscando(false); }
  };
  const req = <span style={{ color: 'red' }}>*</span>;
  return (
    <div className="form-section">
      <div className="form-section-header">
        <div className="form-section-icon">{icono}</div>
        <h4 className="form-section-title">{titulo}</h4>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px', marginTop: '12px' }}>
        <div className="form-group">
          <label>TIPO DOC. {req}</label>
          <select value={p.tipo_documento} onChange={(e) => set('tipo_documento', e.target.value)}>
            {TIPOS_DOC.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>NRO DE DOCUMENTO {req}</label>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input type="text" value={p.documento} onChange={(e) => set('documento', e.target.value.toUpperCase())} style={{ flex: 1 }} />
            <button type="button" className="btn-action btn-modules" onClick={buscar} disabled={buscando}
              style={{ padding: '0 20px', height: '45px', fontWeight: '800' }}>{buscando ? '⏳' : 'CONSULTAR'}</button>
          </div>
        </div>
      </div>
      <div className="form-grid">
        <div className="form-group"><label>NOMBRE / RAZÓN SOCIAL {req}</label>
          <input type="text" value={p.nombre} onChange={(e) => set('nombre', e.target.value.toUpperCase())} /></div>
        <div className="form-group"><label>TELÉFONO</label>
          <input type="text" value={p.telefono} onChange={(e) => set('telefono', e.target.value)} /></div>
        {conContacto && <>
          <div className="form-group"><label>CORREO</label>
            <input type="email" value={p.correo} onChange={(e) => set('correo', e.target.value)} /></div>
          <div className="form-group"><label>DIRECCIÓN</label>
            <input type="text" value={p.direccion} onChange={(e) => set('direccion', e.target.value.toUpperCase())} /></div>
        </>}
      </div>
    </div>
  );
};

const personaVacia = () => ({ tipo_documento: 'CC', documento: '', nombre: '', correo: '', telefono: '', direccion: '', estado_persona: null, tiene_multas: false });

const FormularioTraspaso = ({ subtipo, tipoTramiteId, onClose, onSuccess }) => {
  const cfg = TITULOS[subtipo] || TITULOS.traspaso;
  const [placa, setPlaca] = useState('');
  const [consultando, setConsultando] = useState(false);
  const [info, setInfo] = useState(null);
  const [errorPlaca, setErrorPlaca] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [archivos, setArchivos] = useState({});
  const [comprador, setComprador] = useState(personaVacia());
  const [vendedor, setVendedor] = useState(personaVacia());
  const [observaciones, setObservaciones] = useState('');

  const consultarPlaca = async () => {
    const p = placa.trim().toUpperCase();
    if (p.length < 5) { alert('⚠️ Ingrese la placa del vehículo'); return; }
    setConsultando(true); setErrorPlaca(''); setInfo(null);
    try {
      const res = await axios.get('/api/tramites/traspaso/lookup', { params: { placa: p, subtipo, forzar: true }, timeout: 120000 });
      setInfo(res.data);
    } catch (err) {
      setErrorPlaca(err.response?.data?.message || 'No se pudo consultar la placa');
    } finally { setConsultando(false); }
  };

  const elegirArchivo = (campo, e) => {
    const file = e.target.files[0];
    if (!file) { setArchivos(a => ({ ...a, [campo]: null })); return; }
    const ext = file.name.split('.').pop().toLowerCase();
    if (!EXT_OK.includes(ext)) { alert(`❌ "${file.name}" no es PDF ni imagen.`); e.target.value = ''; return; }
    if (file.size > 6 * 1024 * 1024) { alert(`❌ "${file.name}" supera los 6MB`); e.target.value = ''; return; }
    setArchivos(a => ({ ...a, [campo]: file }));
  };

  const enviar = async () => {
    if (!info || !info.puede_crear) { alert('⚠️ Consulte primero una placa que cumpla los requisitos'); return; }
    if (!comprador.nombre.trim() || !comprador.documento.trim()) { alert('⚠️ Complete los datos del comprador'); return; }
    if (!vendedor.nombre.trim() || !vendedor.documento.trim()) { alert('⚠️ Complete los datos del vendedor'); return; }
    const faltan = DOCUMENTOS.filter(d => !archivos[d.campo]).map(d => d.etiqueta);
    if (faltan.length) { alert(`⚠️ Faltan documentos obligatorios:\n• ${faltan.join('\n• ')}`); return; }
    const total = DOCUMENTOS.reduce((a, d) => a + (archivos[d.campo]?.size || 0), 0);
    if (total > 25 * 1024 * 1024) { alert('❌ La suma de los archivos no puede superar 25MB'); return; }

    setEnviando(true);
    const data = new FormData();
    data.append('transito_id', info.transito.id);
    data.append('tipo_tramite_id', info.tipo_tramite_id || tipoTramiteId);
    data.append('placa_referencia', info.placa);
    data.append('datos_adicionales', JSON.stringify({
      placa_referencia: info.placa, observaciones,
      propietario: comprador.nombre, tipo_documento: comprador.tipo_documento, documento: comprador.documento,
      correo: comprador.correo, telefono: comprador.telefono, direccion: comprador.direccion,
      estado_persona: comprador.estado_persona, tiene_multas: comprador.tiene_multas,
      vendedor_nombre: vendedor.nombre, vendedor_tipo_documento: vendedor.tipo_documento, vendedor_documento: vendedor.documento,
      vendedor_telefono: vendedor.telefono, vendedor_estado_persona: vendedor.estado_persona, vendedor_tiene_multas: vendedor.tiene_multas
    }));
    DOCUMENTOS.forEach(d => data.append(d.campo, archivos[d.campo]));
    try {
      await axios.post('/api/tramites', data, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 180000 });
      alert(`✅ ${cfg.titulo} radicado correctamente`);
      onSuccess(); onClose();
    } catch (err) {
      alert('❌ Error: ' + (err.response?.data?.message || 'No se pudo crear el trámite'));
    } finally { setEnviando(false); }
  };

  const req = <span style={{ color: 'red' }}>*</span>;
  const v = info?.vehiculo || {};

  return (
    <div>
      <div className="form-section">
        <div className="form-section-header">
          <div className="form-section-icon">🚗</div>
          <h4 className="form-section-title">PLACA DEL {cfg.titulo}</h4>
        </div>
        <small style={{ display: 'block', margin: '8px 0' }}>
          Se consulta el RUNT: el vehículo debe tener SOAT y revisión técnico-mecánica activos, y la placa debe tener registrado en el sistema el CUPL de {cfg.titulo.toLowerCase()} ({cfg.valor}).
        </small>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input type="text" value={placa} maxLength={7} placeholder="PLACA"
            onChange={(e) => { setPlaca(e.target.value.toUpperCase()); setInfo(null); setErrorPlaca(''); }}
            onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), consultarPlaca())}
            style={{ flex: 1, textTransform: 'uppercase', fontWeight: 'bold' }} />
          <button type="button" className="btn-action btn-modules" onClick={consultarPlaca} disabled={consultando}
            style={{ padding: '0 20px', height: '45px', fontWeight: '800' }}>
            {consultando ? '⏳ CONSULTANDO...' : 'CONSULTAR'}
          </button>
        </div>
        {consultando && <small style={{ display: 'block', marginTop: '6px' }}>Consultando el RUNT, puede tardar hasta 30 segundos...</small>}
        {errorPlaca && <div className="error-banner" style={{ marginTop: '10px' }}>{errorPlaca}</div>}
        {info && (
          <div style={{ marginTop: '12px', padding: '12px', borderRadius: '8px', border: '1px solid var(--card-border)', background: 'var(--secondary-soft)', fontSize: '13px', display: 'grid', gap: '6px' }}>
            <div><b>Vehículo:</b> {[v.marca, v.linea, v.modelo, v.color, v.clase].filter(Boolean).join(' · ') || 'sin datos'}</div>
            <Estado ok={info.soat?.ok}>SOAT {info.soat?.ok ? `vigente${info.soat.fecha_fin ? ' hasta ' + info.soat.fecha_fin : ''}` : 'NO vigente'}</Estado>
            <Estado ok={info.rtm?.ok}>
              Revisión técnico-mecánica {info.rtm?.ok ? (info.rtm.estado === 'no_aplica' ? 'no aplica (vehículo nuevo)' : 'vigente') : 'NO vigente'}
            </Estado>
            <Estado ok={!!info.cupl}>
              {info.cupl ? `CUPL ${info.cupl.numero} registrado (${info.cupl.pagado ? 'pagado' : 'pendiente de pago'})` : `Sin CUPL de ${cfg.titulo.toLowerCase()} registrado`}
            </Estado>
            {info.transito && <div><b>Organismo de tránsito:</b> {info.transito.nombre}</div>}
            {(info.bloqueos || []).map((b, i) => <div key={i} className="error-banner" style={{ marginTop: '4px' }}>{b}</div>)}
          </div>
        )}
      </div>

      {info && info.puede_crear && (
        <>
          <Persona titulo="VENDEDOR (PROPIETARIO ACTUAL)" icono="🧾" p={vendedor} setP={setVendedor} />
          <Persona titulo="COMPRADOR (NUEVO PROPIETARIO)" icono="👤" p={comprador} setP={setComprador} conContacto />

          <div className="form-section">
            <div className="form-section-header">
              <div className="form-section-icon">📎</div>
              <h4 className="form-section-title">DOCUMENTOS</h4>
            </div>
            {DOCUMENTOS.map(d => (
              <div className="form-group" key={d.campo}>
                <label>{d.etiqueta} {req}</label>
                <input type="file" accept=".pdf,.jpg,.jpeg,.png,.webp" onChange={(e) => elegirArchivo(d.campo, e)} />
                {archivos[d.campo] && <small style={{ color: '#16a34a' }}>✓ {archivos[d.campo].name}</small>}
              </div>
            ))}
            <div className="form-group">
              <label>OBSERVACIONES</label>
              <textarea value={observaciones} onChange={(e) => setObservaciones(e.target.value.toUpperCase())} rows={2} />
            </div>
          </div>
        </>
      )}

      <div className="modal-actions" style={{ padding: '0 20px 20px 20px' }}>
        <button type="button" onClick={onClose} className="btn-secondary" disabled={enviando}>cancelar</button>
        <button type="button" onClick={enviar} className="btn-primary" disabled={enviando || !info || !info.puede_crear}
          style={{ padding: '10px 25px', fontSize: '13px', fontWeight: '800' }}>
          {enviando ? '🚀 ENVIANDO...' : `🚀 RADICAR ${cfg.titulo}`}
        </button>
      </div>
    </div>
  );
};

export default FormularioTraspaso;
